import React,{useState} from "react";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import { upload_document, upload_document_v2 } from "./GhareluRenews";

import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import api, { url } from "../../../../../api/api";
import { toast } from "react-toastify";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const OldGhaleru = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [cmpId, setCmpId] = useState(null);

  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    data.documents = docsOutput;
    data.company = cmpId
    data.amendment_type = "gharelu_renewal";

    const user = JSON.parse(localStorage.getItem("user"));
    data.user = user.user_id;

    api.post('services/company/amendments/', data)
      .then((response) => {
        toast.success("Data Registered Successfully")
        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"
       
        // };

        
        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });
      })
      .catch((error) => {
        toast.success("Something went wrong")
      });
  };

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  return (
    <form>
      {/* company name and other details */}
      {/* <div className="flex-col flex md:flex-row flex-wrap">
        <div className="flex flex-wrap border-2 border-primary-blue">
          <p className="text-primary-red flex-nowrap items-center shrink-0 flex font-bold text-base">
            कम्पनी वा ब्यवसायको नाम:
          </p>
          <input className="py-2" type="search" placeholder="Search" />
        </div>
        <div className="flex flex-wrap w-fit border-2 border-primary-blue">
          <p className="text-primary-red flex items-center font-bold text-base">
            ठेगाना :
          </p>
          <input className=" " type="" placeholder="" />
        </div>
        <div className="flex flex-wrap w-fit border-2 border-primary-blue">
          <p className="text-primary-red flex items-center font-bold text-base">
            स. ब्यक्तिको नाम :
          </p>
          <input className=" " type="text" placeholder="" />
        </div>
        <div className="flex flex-wrap w-fit border-2 border-primary-blue">
          <p className="text-primary-red flex items-center font-bold text-base">
            सम्पर्क नं. :
          </p>
          <input className=" " type="text" placeholder="" />
        </div>
      </div> */}
      <BusinessSearchNDetails setCmpId={setCmpId}/>
      {/* compnay name and other details close */}


      <div className="border-2 bg-pink-100 border-primary-blue mt-3">
        <p className="text-primary-blue mt-0 text-lg font-semibold leading-10 text-center">
          घरेलुमा नविकरण सम्बन्धि काम गर्दा शेवा शुल्क वापतको रकम रु.५,०००।–
          मात्र लाग्नेछ ।
        </p>
      </div>
      <div className=" border-primary-blue mt-3">
        <p className="flex text-primary-blue mt-0 font-semibold leading-10 text-center">
          <span className=" text-primary-red mr-2">नोट :</span>
          घरेलुमा दर्ता गर्दा राखेको पुँजीको आधारमा राजश्व रकम थप लाग्नेछ ।
        </p>
      </div>

      {/* upload documents open */}
      <div className="text-primary-blue text-lg underline mt-4">
        2. Upload Document
        <span className="text-primary-blue underline">
          (घरेलुमा नविकरण गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु ग्उयिबम
          गर्नुहोस ।)
        </span>
      </div>

      <Documents
        documents_data={upload_document}
        initialState={data}
        setDocument={setDocsOutput}
      />

      {/* upload documents close */}

      {/* <FormBranch /> */}
      <div className="text-primary-blue text-lg my-5 mb-6 underline">
              3. Working Branch
              <span className="text-primary-blue underline mx-2 ">
                (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
              </span>
            </div>
      <FormBranch register={register} name={"working_branch"} />
      <FormButtom />
      
      <NewFormPayment handleSubmit={handleSubmit} handleClick={handleClick}
      setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default OldGhaleru;
